import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["productType"];
import React from 'react';
import { CreditCardSearch, PersonalLoansSearch } from '@nerdwallet/react-marketplace-search';
import { PRODUCT_TYPES } from '@nerdwallet/nw-api-sdk/marketplace';
import { STATIC_PERSONAL_LOANS } from '../../lib/product-constants';

var SearchWrapper = function SearchWrapper(_ref) {
  var productType = _ref.productType,
      props = _objectWithoutProperties(_ref, _excluded);

  switch (productType) {
    case PRODUCT_TYPES.CREDIT_CARDS:
      return /*#__PURE__*/React.createElement(CreditCardSearch, props);

    case PRODUCT_TYPES.PERSONAL_LOANS:
    case STATIC_PERSONAL_LOANS:
      return /*#__PURE__*/React.createElement(PersonalLoansSearch, props);

    default:
      return /*#__PURE__*/React.createElement("div", null, "No search component exists for ".concat(productType));
  }
};

export default SearchWrapper;